(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fh-about-stats"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var stats = document.querySelectorAll('[data-fh-stat]');
  if (!stats.length) return;

  var animated = new WeakSet();

  function animateCount(el) {
    var target = parseInt(el.getAttribute('data-target'), 10) || 0;
    var valueEl = el.querySelector('[data-fh-stat-value]');
    var duration = 1400;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      valueEl.textContent = Math.floor(eased * target).toLocaleString('en-IN');
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        valueEl.textContent = target.toLocaleString('en-IN');
      }
    }
    requestAnimationFrame(step);
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting && !animated.has(entry.target)) {
        animated.add(entry.target);
        animateCount(entry.target);
      }
    });
  }, { threshold: 0.4 });

  stats.forEach(function (stat) { observer.observe(stat); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-about-values"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var cards = document.querySelectorAll('[data-fh-reveal]');
  if (!cards.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry, i) {
      if (entry.isIntersecting) {
        setTimeout(function () {
          entry.target.classList.add('is-visible');
        }, i * 80);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  cards.forEach(function (card) { observer.observe(card); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-announcement-bar"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var rotators = document.querySelectorAll('[data-fh-announce-rotator]');

  rotators.forEach(function (rotator) {
    var slides = rotator.querySelectorAll('[data-fh-announce-slide]');
    if (slides.length <= 1) return;

    var current = 0;

    setInterval(function () {
      var activeSlide = slides[current];
      var nextIndex = (current + 1) % slides.length;
      var nextSlide = slides[nextIndex];

      activeSlide.classList.remove('is-active');
      activeSlide.classList.add('is-leaving');

      nextSlide.classList.add('is-active');

      setTimeout(function () {
        activeSlide.classList.remove('is-leaving');
      }, 400);

      current = nextIndex;
    }, 3500);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-bestsellers"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.fh-best');

  sections.forEach(function (section) {
    var track = section.querySelector('[data-fh-best-track]');
    var prevBtn = section.querySelector('[data-fh-best-prev]');
    var nextBtn = section.querySelector('[data-fh-best-next]');

    if (!track) return;

    function getScrollAmount() {
      var card = track.querySelector('.fh-best__card');
      if (!card) return 300;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.gap) || 20;
      return card.offsetWidth + gap;
    }

    function updateNavState() {
      if (!prevBtn || !nextBtn) return;
      prevBtn.disabled = track.scrollLeft <= 4;
      nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateNavState);
    updateNavState();

    var addButtons = section.querySelectorAll('[data-fh-add-to-cart]');
    addButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        btn.disabled = true;
        var originalLabel = btn.querySelector('.fh-best__add-label').textContent;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(function () {
            btn.classList.add('is-added');
            btn.querySelector('.fh-best__add-label').textContent = 'Added';

            return fetch('/cart.js').then(function (res) { return res.json(); });
          })
          .then(function (cart) {
            if (window.fhUpdateCartState) window.fhUpdateCartState(cart);
            if (window.fhOpenCart) window.fhOpenCart();

            setTimeout(function () {
              btn.classList.remove('is-added');
              btn.querySelector('.fh-best__add-label').textContent = originalLabel;
              btn.disabled = false;
            }, 1800);
          })
          .catch(function () {
            btn.disabled = false;
          });
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-collection-page"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var sortSelect = document.querySelector('[data-fh-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  var filterToggle = document.querySelector('[data-fh-filter-toggle]');
  var filterClose = document.querySelector('[data-fh-filter-close]');
  var sidebar = document.querySelector('[data-fh-filter-sidebar]');
  var overlay = document.querySelector('[data-fh-filter-overlay]');

  function openFilters() {
    sidebar.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeFilters() {
    sidebar.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (filterToggle) filterToggle.addEventListener('click', openFilters);
  if (filterClose) filterClose.addEventListener('click', closeFilters);
  if (overlay) overlay.addEventListener('click', closeFilters);

  var filterGroups = document.querySelectorAll('[data-fh-filter-group-toggle]');
  filterGroups.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var panel = toggle.nextElementSibling;
      var isOpen = panel.style.display !== 'none';
      panel.style.display = isOpen ? 'none' : 'flex';
    });
  });

  var filterInputs = document.querySelectorAll('[data-fh-filter-input]');
  filterInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      var url = input.checked
        ? input.getAttribute('data-filter-url')
        : input.getAttribute('data-filter-remove-url');
      if (url) window.location.href = url;
    });
  });

  var addButtons = document.querySelectorAll('[data-fh-add-to-cart]');
  addButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      btn.disabled = true;
      var label = btn.querySelector('.fh-product-card__add-label');
      var originalText = label.textContent;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add failed');
          return res.json();
        })
        .then(function () {
          btn.classList.add('is-added');
          label.textContent = 'Added';
          return fetch('/cart.js').then(function (res) { return res.json(); });
        })
        .then(function (cart) {
          if (window.fhUpdateCartState) window.fhUpdateCartState(cart);
          if (window.fhOpenCart) window.fhOpenCart();

          setTimeout(function () {
            btn.classList.remove('is-added');
            label.textContent = originalText;
            btn.disabled = false;
          }, 1800);
        })
        .catch(function () {
          btn.disabled = false;
        });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-faq-page"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var items = document.querySelectorAll('[data-fh-faq-item]');
  var catButtons = document.querySelectorAll('[data-fh-faq-cat]');
  var searchInput = document.querySelector('[data-fh-faq-search]');
  var noResults = document.querySelector('[data-fh-faq-no-results]');
  var activeCategory = 'all';

  items.forEach(function (item) {
    var toggle = item.querySelector('[data-fh-faq-toggle]');
    var panel = item.querySelector('[data-fh-faq-panel]');

    toggle.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');

      items.forEach(function (other) {
        other.classList.remove('is-open');
        other.querySelector('[data-fh-faq-panel]').style.maxHeight = null;
      });

      if (!isOpen) {
        item.classList.add('is-open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });

  function applyFilters() {
    var query = searchInput ? searchInput.value.trim().toLowerCase() : '';
    var visibleCount = 0;

    items.forEach(function (item) {
      var matchesCategory = activeCategory === 'all' || item.getAttribute('data-category') === activeCategory;
      var matchesSearch = query === '' ||
        item.getAttribute('data-question').indexOf(query) !== -1 ||
        item.getAttribute('data-answer').indexOf(query) !== -1;

      var isVisible = matchesCategory && matchesSearch;
      item.style.display = isVisible ? '' : 'none';
      if (isVisible) visibleCount++;
    });

    if (noResults) {
      noResults.hidden = visibleCount > 0;
    }
  }

  catButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      catButtons.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      activeCategory = btn.getAttribute('data-fh-faq-cat');
      applyFilters();
    });
  });

  if (searchInput) {
    searchInput.addEventListener('input', applyFilters);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var items = document.querySelectorAll('[data-fh-faq-item]');

  items.forEach(function (item) {
    var toggle = item.querySelector('[data-fh-faq-toggle]');
    var panel = item.querySelector('[data-fh-faq-panel]');

    toggle.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');

      items.forEach(function (other) {
        other.classList.remove('is-open');
        other.querySelector('[data-fh-faq-panel]').style.maxHeight = null;
      });

      if (!isOpen) {
        item.classList.add('is-open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-footer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var accordions = document.querySelectorAll('[data-fh-footer-accordion]');

  accordions.forEach(function (acc) {
    var toggle = acc.querySelector('[data-fh-footer-toggle]');
    var panel = acc.querySelector('[data-fh-footer-panel]');

    toggle.addEventListener('click', function () {
      var isOpen = acc.classList.contains('is-open');
      var isMobile = window.matchMedia('(max-width: 600px)').matches;

      if (!isMobile) return;

      if (isOpen) {
        acc.classList.remove('is-open');
        panel.style.maxHeight = null;
      } else {
        acc.classList.add('is-open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('.fh-header');
  if (!header) return;

  var menuToggle = header.querySelector('[data-fh-menu-toggle]');
  var drawer = document.querySelector('[data-fh-drawer]');
  var overlay = document.querySelector('[data-fh-drawer-overlay]');
  var drawerClose = document.querySelector('[data-fh-drawer-close]');

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (menuToggle) {
    menuToggle.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });
  }

  if (drawerClose) {
    drawerClose.addEventListener('click', closeDrawer);
  }

  if (overlay) {
    overlay.addEventListener('click', closeDrawer);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* Desktop dropdown menus — hover to open (with small close delay), click still works for touch/keyboard */
  var dropdowns = header.querySelectorAll('[data-fh-dropdown]');
  var closeTimer;

  dropdowns.forEach(function (dropdown) {
    var toggle = dropdown.querySelector('[data-fh-dropdown-toggle]');

    dropdown.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      dropdowns.forEach(function (d) { d.classList.remove('is-open'); });
      dropdown.classList.add('is-open');
    });

    dropdown.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(function () {
        dropdown.classList.remove('is-open');
      }, 150);
    });

    // Fallback for touch/keyboard users
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = dropdown.classList.contains('is-open');
      dropdowns.forEach(function (d) { d.classList.remove('is-open'); });
      if (!isOpen) dropdown.classList.add('is-open');
    });
  });

  document.addEventListener('click', function (e) {
    dropdowns.forEach(function (d) {
      if (!d.contains(e.target)) d.classList.remove('is-open');
    });
  });

  /* Mobile drawer accordions (nested menu expand/collapse) */
  var accordions = drawer.querySelectorAll('[data-fh-accordion]');
  accordions.forEach(function (acc) {
    var toggle = acc.querySelector(':scope > [data-fh-accordion-toggle]');
    var panel = acc.querySelector(':scope > [data-fh-accordion-panel]');

    toggle.addEventListener('click', function () {
      var isOpen = acc.classList.contains('is-open');
      if (isOpen) {
        acc.classList.remove('is-open');
        panel.style.maxHeight = null;
      } else {
        acc.classList.add('is-open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
      var parentPanel = acc.parentElement.closest('[data-fh-accordion-panel]');
      if (parentPanel) {
        setTimeout(function () {
          parentPanel.style.maxHeight = parentPanel.scrollHeight + 'px';
        }, 260);
      }
    });
  });

  /* Predictive search (desktop only, box hidden below 990px) */
  var searchWrap = header.querySelector('[data-fh-search]');
  var input = header.querySelector('[data-fh-search-input]');
  var clearBtn = header.querySelector('[data-fh-search-clear]');
  var resultsBox = header.querySelector('[data-fh-search-results]');
  var debounceTimer;

  function closeResults() {
    resultsBox.hidden = true;
    resultsBox.innerHTML = '';
  }

  function renderResults(data, query) {
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];

    if (!products.length) {
      resultsBox.innerHTML = '<div class="fh-search__empty">No results for "' + query + '"</div>';
      resultsBox.hidden = false;
      return;
    }

    var html = products.slice(0, 6).map(function (p) {
      var img = p.featured_image ? p.featured_image.url : '';
      return '<a href="' + p.url + '" class="fh-search__result-item">' +
        (img ? '<img class="fh-search__result-img" src="' + img + '" alt="' + p.title + '">' : '<div class="fh-search__result-img"></div>') +
        '<div class="fh-search__result-info">' +
          '<span class="fh-search__result-title">' + p.title + '</span>' +
          '<span class="fh-search__result-price">' + p.price + '</span>' +
        '</div>' +
      '</a>';
    }).join('');

    html += '<a href="/search?q=' + encodeURIComponent(query) + '" class="fh-search__view-all">View all results for "' + query + '"</a>';

    resultsBox.innerHTML = html;
    resultsBox.hidden = false;
  }

  if (input) {
    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearBtn.hidden = query.length === 0;

      clearTimeout(debounceTimer);

      if (query.length < 2) {
        closeResults();
        return;
      }

      debounceTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,vendor')
          .then(function (res) { return res.json(); })
          .then(function (data) { renderResults(data, query); })
          .catch(function () { closeResults(); });
      }, 250);
    });

    clearBtn.addEventListener('click', function () {
      input.value = '';
      clearBtn.hidden = true;
      closeResults();
      input.focus();
    });

    document.addEventListener('click', function (e) {
      if (!searchWrap.contains(e.target)) {
        closeResults();
      }
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeResults();
        input.blur();
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-hero"] && !Shopify.designMode) return;
  try {
    
function fhHeroInitAll() {
  document.querySelectorAll('.fh-hero').forEach(fhHeroInit);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', fhHeroInitAll);
} else {
  fhHeroInitAll();
}

function fhHeroInit(root) {
  if (root.dataset.fhHeroInit) return;
  root.dataset.fhHeroInit = 'true';

  var slides = Array.prototype.slice.call(root.querySelectorAll('.fh-hero__slide'));
  var dots = Array.prototype.slice.call(root.querySelectorAll('.fh-hero__dot'));
  var prevBtn = root.querySelector('.fh-hero__arrow--prev');
  var nextBtn = root.querySelector('.fh-hero__arrow--next');
  if (slides.length < 2) return;

  var current = 0;
  var autoplay = root.dataset.autoplay !== 'false';
  var speed = (parseFloat(root.dataset.autoplaySpeed) || 3) * 1000;
  var timer = null;

  function goTo(index) {
    index = (index + slides.length) % slides.length;
    slides[current].classList.remove('is-active');
    if (dots[current]) dots[current].classList.remove('is-active');
    current = index;
    slides[current].classList.add('is-active');
    if (dots[current]) dots[current].classList.add('is-active');
  }
  function next() { goTo(current + 1); }
  function prev() { goTo(current - 1); }

  function startAutoplay() {
    stopAutoplay();
    if (autoplay) timer = setInterval(next, speed);
  }
  function stopAutoplay() {
    if (timer) clearInterval(timer);
    timer = null;
  }

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      goTo(parseInt(dot.dataset.index, 10));
      startAutoplay();
    });
  });
  if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
  if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });

  root.addEventListener('mouseenter', stopAutoplay);
  root.addEventListener('mouseleave', startAutoplay);

  document.addEventListener('shopify:block:select', function (evt) {
    var idx = slides.findIndex(function (s) { return s === evt.target || s.contains(evt.target); });
    if (idx > -1) { stopAutoplay(); goTo(idx); }
  });
  document.addEventListener('shopify:block:deselect', function () {
    startAutoplay();
  });

  startAutoplay();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-new-arrivals"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.fh-new');

  sections.forEach(function (section) {
    var track = section.querySelector('[data-fh-new-track]');
    var prevBtn = section.querySelector('[data-fh-new-prev]');
    var nextBtn = section.querySelector('[data-fh-new-next]');

    if (!track) return;

    function getScrollAmount() {
      var card = track.querySelector('.fh-new__card');
      if (!card) return 300;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.gap) || 20;
      return card.offsetWidth + gap;
    }

    function updateNavState() {
      if (!prevBtn || !nextBtn) return;
      prevBtn.disabled = track.scrollLeft <= 4;
      nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateNavState);
    updateNavState();

    var addButtons = section.querySelectorAll('[data-fh-add-to-cart]');
    addButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        btn.disabled = true;
        var originalLabel = btn.querySelector('.fh-new__add-label').textContent;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(function () {
            btn.classList.add('is-added');
            btn.querySelector('.fh-new__add-label').textContent = 'Added';
            return fetch('/cart.js').then(function (res) { return res.json(); });
          })
          .then(function (cart) {
            if (window.fhUpdateCartState) window.fhUpdateCartState(cart);
            if (window.fhOpenCart) window.fhOpenCart();

            setTimeout(function () {
              btn.classList.remove('is-added');
              btn.querySelector('.fh-new__add-label').textContent = originalLabel;
              btn.disabled = false;
            }, 1800);
          })
          .catch(function () {
            btn.disabled = false;
          });
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-product-page"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var pdp = document.querySelector('.fh-pdp');
  if (!pdp) return;

  /* ---------- Gallery: swipe slider + thumbs ---------- */
  var slider = pdp.querySelector('[data-fh-slider]');
  var slides = slider ? slider.querySelectorAll('.fh-pdp__slide') : [];
  var thumbs = pdp.querySelectorAll('[data-fh-thumb]');
  var thumbsTrack = pdp.querySelector('[data-fh-thumbs-track]');
  var thumbPrev = pdp.querySelector('[data-fh-thumb-prev]');
  var thumbNext = pdp.querySelector('[data-fh-thumb-next]');
  var current = 0;
  var jumping = false;

  function setActive(i) {
    if (i === current || i < 0 || i >= slides.length) return;
    current = i;
    thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
    var t = thumbs[i];
    if (t && thumbsTrack) {
      var tr = thumbsTrack.getBoundingClientRect();
      var r = t.getBoundingClientRect();
      thumbsTrack.scrollBy({ left: r.left - tr.left - (tr.width - r.width) / 2, behavior: 'smooth' });
    }
  }

  if (slider) {
    var ticking = false;
    slider.addEventListener('scroll', function () {
      if (ticking || jumping) return;
      ticking = true;
      requestAnimationFrame(function () {
        setActive(Math.round(slider.scrollLeft / slider.clientWidth));
        ticking = false;
      });
    }, { passive: true });

    /* Instant jump: kills any in-progress swipe momentum, no snap fight */
    function jumpTo(i) {
      var slide = slides[i];
      if (!slide) return;
      jumping = true;
      slider.classList.add('is-jumping');
      slider.scrollLeft = slide.offsetLeft;
      setActive(i);
      requestAnimationFrame(function () {
        slider.scrollLeft = slide.offsetLeft;
        slider.classList.remove('is-jumping');
        jumping = false;
      });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        jumpTo(i);
      });
    });

    window.addEventListener('resize', function () {
      if (slides[current]) slider.scrollLeft = slides[current].offsetLeft;
    });

    /* Preload all gallery images once the page has loaded, so tapping a thumbnail never waits */
    window.addEventListener('load', function () {
      slider.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        img.loading = 'eager';
      });
    });

    /* Desktop hover zoom that follows the cursor */
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      slider.querySelectorAll('.fh-pdp__slide').forEach(function (slide) {
        var img = slide.querySelector('img');
        if (!img) return;
        slide.addEventListener('mousemove', function (e) {
          var rect = slide.getBoundingClientRect();
          img.style.transformOrigin =
            ((e.clientX - rect.left) / rect.width * 100) + '% ' +
            ((e.clientY - rect.top) / rect.height * 100) + '%';
        });
        slide.addEventListener('mouseleave', function () {
          img.style.transformOrigin = 'center';
        });
      });
    }
  }

  /* Thumbnail row scroll arrows */
  if (thumbsTrack && thumbPrev && thumbNext) {
    function updateThumbNavState() {
      thumbPrev.disabled = thumbsTrack.scrollLeft <= 4;
      thumbNext.disabled = thumbsTrack.scrollLeft >= thumbsTrack.scrollWidth - thumbsTrack.clientWidth - 4;
    }

    thumbPrev.addEventListener('click', function () {
      thumbsTrack.scrollBy({ left: -160, behavior: 'smooth' });
    });

    thumbNext.addEventListener('click', function () {
      thumbsTrack.scrollBy({ left: 160, behavior: 'smooth' });
    });

    thumbsTrack.addEventListener('scroll', updateThumbNavState);
    updateThumbNavState();
  }

  /* Quantity stepper */
  var qtyInput = pdp.querySelector('[data-fh-qty-input]');
  var qtyMinus = pdp.querySelector('[data-fh-qty-minus]');
  var qtyPlus = pdp.querySelector('[data-fh-qty-plus]');

  if (qtyMinus) {
    qtyMinus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = Math.max(1, val - 1);
    });
  }

  if (qtyPlus) {
    qtyPlus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
    });
  }

  /* Variant options -> hidden select */
  var variantSelect = pdp.querySelector('[data-fh-variant-select]');
  var optionGroups = pdp.querySelectorAll('[data-fh-option-index]');
  var addBtn = pdp.querySelector('[data-fh-pdp-add-to-cart]');
  var addLabel = pdp.querySelector('[data-fh-pdp-add-label]');
  var priceGroup = pdp.querySelector('.fh-pdp__price-group');

  function getSelectedOptions() {
    var selected = [];
    optionGroups.forEach(function (group) {
      var activeBtn = group.querySelector('.is-selected');
      selected.push(activeBtn ? activeBtn.getAttribute('data-fh-option-value') : null);
    });
    return selected;
  }

  function updateVariantState() {
    if (!variantSelect) return;
    var selected = getSelectedOptions();
    var options = variantSelect.querySelectorAll('option');
    var matchedOption = null;

    options.forEach(function (opt) {
      var optValues = [opt.getAttribute('data-option1'), opt.getAttribute('data-option2'), opt.getAttribute('data-option3')];
      var isMatch = selected.every(function (val, i) {
        return val === null || val === optValues[i];
      });
      if (isMatch && !matchedOption) matchedOption = opt;
    });

    if (matchedOption) {
      variantSelect.value = matchedOption.value;
      var available = matchedOption.getAttribute('data-available') === 'true';
      var price = matchedOption.getAttribute('data-price');
      var comparePrice = matchedOption.getAttribute('data-compare-price');

      if (addBtn) {
        addBtn.disabled = !available;
        if (addLabel) addLabel.textContent = available ? 'Add to Cart' : 'Sold Out';
      }

      if (priceGroup && price) {
        var hasCompare = comparePrice && comparePrice !== '₹0' && comparePrice !== price;

        if (hasCompare) {
          var comparePriceNum = parseFloat(comparePrice.replace(/[^0-9.]/g, ''));
          var priceNum = parseFloat(price.replace(/[^0-9.]/g, ''));
          var discountPct = Math.round(((comparePriceNum - priceNum) / comparePriceNum) * 100);

          priceGroup.innerHTML =
            '<span class="fh-pdp__price fh-pdp__price--sale">' + price + '</span>' +
            '<span class="fh-pdp__price-compare">' + comparePrice + '</span>' +
            '<span class="fh-pdp__discount-tag">' + discountPct + '% off</span>';
        } else {
          priceGroup.innerHTML = '<span class="fh-pdp__price">' + price + '</span>';
        }
      }
    }
  }

  optionGroups.forEach(function (group) {
    var buttons = group.querySelectorAll('[data-fh-option-value]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');

        var selectedLabel = pdp.querySelector('[data-fh-option-selected-label]');
        if (btn.classList.contains('fh-pdp__swatch-btn') && selectedLabel) {
          selectedLabel.textContent = btn.getAttribute('data-fh-swatch-name');
        }

        updateVariantState();
      });
    });

    buttons.forEach(function (btn) {
      if (btn.classList.contains('fh-pdp__swatch-btn')) {
        var bg = getComputedStyle(btn).backgroundColor;
        if (bg === 'rgba(0, 0, 0, 0)' || bg === 'transparent') {
          btn.classList.add('fh-pdp__swatch-btn--fallback');
          btn.textContent = btn.getAttribute('data-fh-swatch-name').charAt(0).toUpperCase();
        }
      }
    });
  });

  // Sync price/availability to whatever variant is selected by default on page load
  updateVariantState();

  /* Accordions */
  var accordions = pdp.querySelectorAll('[data-fh-pdp-accordion]');
  accordions.forEach(function (acc) {
    var toggle = acc.querySelector('[data-fh-pdp-accordion-toggle]');
    var panel = acc.querySelector('.fh-pdp__accordion-panel');

    toggle.addEventListener('click', function () {
      var isOpen = acc.classList.contains('is-open');
      if (isOpen) {
        acc.classList.remove('is-open');
        panel.style.maxHeight = null;
      } else {
        acc.classList.add('is-open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });

  /* Add to cart (AJAX) */
  var form = document.getElementById('fh-pdp-form');
  if (form && addBtn) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn.disabled) return;

      addBtn.disabled = true;
      var originalText = addLabel.textContent;

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add failed');
          return res.json();
        })
        .then(function () {
          addBtn.classList.add('is-added');
          addLabel.textContent = 'Added!';
          return fetch('/cart.js').then(function (res) { return res.json(); });
        })
        .then(function (cart) {
          if (window.fhUpdateCartState) window.fhUpdateCartState(cart);
          if (window.fhOpenCart) window.fhOpenCart();

          setTimeout(function () {
            addBtn.classList.remove('is-added');
            addLabel.textContent = originalText;
            addBtn.disabled = false;
          }, 1800);
        })
        .catch(function () {
          addBtn.disabled = false;
        });
    });
  }

  /* Buy Now -> add then redirect to checkout */
  var buyNowBtn = pdp.querySelector('[data-fh-buy-now]');
  if (buyNowBtn && form) {
    buyNowBtn.addEventListener('click', function () {
      buyNowBtn.disabled = true;
      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add failed');
          return res.json();
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function () {
          buyNowBtn.disabled = false;
        });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-recently-viewed"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var STORAGE_KEY = 'fh_recently_viewed';
  var MAX_ITEMS = 8;

  function getStored() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveStored(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
  }

  // Record current product if on a product page
  var currentProductScript = document.querySelector('[data-fh-current-product]');
  if (currentProductScript) {
    try {
      var current = JSON.parse(currentProductScript.textContent);
      var items = getStored().filter(function (item) { return item.id !== current.id; });
      items.unshift(current);
      items = items.slice(0, MAX_ITEMS);
      saveStored(items);
    } catch (e) {}
  }

  // Render the strip, excluding the current product
  var section = document.querySelector('[data-fh-recent-section]');
  var track = document.querySelector('[data-fh-recent-track]');
  if (!section || !track) return;

  var stored = getStored();
  var currentId = currentProductScript ? JSON.parse(currentProductScript.textContent).id : null;
  var toShow = stored.filter(function (item) { return item.id !== currentId; });

  if (toShow.length === 0) return;

  track.innerHTML = toShow.map(function (item) {
    return (
      '<a href="' + item.url + '" class="fh-recent-card">' +
        (item.image ? '<img class="fh-recent-card__image" src="' + item.image + '" alt="' + item.title + '">' : '<div class="fh-recent-card__image"></div>') +
        '<p class="fh-recent-card__title">' + item.title + '</p>' +
        '<span class="fh-recent-card__price">' + item.price + '</span>' +
      '</a>'
    );
  }).join('');

  section.style.display = 'block';
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-related-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var addButtons = document.querySelectorAll('[data-fh-related-add-to-cart]');

  addButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      btn.disabled = true;
      var label = btn.querySelector('[data-fh-related-add-label]');
      var originalText = label.textContent;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add failed');
          return res.json();
        })
        .then(function () {
          btn.classList.add('is-added');
          label.textContent = 'Added';
          return fetch('/cart.js').then(function (res) { return res.json(); });
        })
        .then(function (cart) {
          if (window.fhUpdateCartState) window.fhUpdateCartState(cart);
          if (window.fhOpenCart) window.fhOpenCart();

          setTimeout(function () {
            btn.classList.remove('is-added');
            label.textContent = originalText;
            btn.disabled = false;
          }, 1800);
        })
        .catch(function () {
          btn.disabled = false;
        });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
